__turbopack_context__.v({
  "wrapper": "FullWidth-module__m49v2a__wrapper",
});
